import React, { useEffect, useState } from "react";

// const loaderStyle: React.CSSProperties = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   height: "100vh",
//   width: "100vw",
//   backgroundColor: "rgba(255, 255, 255, 0.8)",
//   zIndex: 9999,
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// };

// const spinnerStyle: React.CSSProperties = {
//   width: "50px",
//   height: "50px",
//   border: "6px solid #F59620",
//   borderTop: "6px solid transparent",
//   borderRadius: "50%",
//   animation: "spin 1s linear infinite",
// };

// const spinnerKeyframes = `
//   @keyframes spin {
//     0% { transform: rotate(0deg); }
//     100% { transform: rotate(360deg); }
//   }
// `;

// const Loader: React.FC = () => (
//   <>
//     <style>{spinnerKeyframes}</style>
//     <div style={loaderStyle}>
//       <div style={spinnerStyle}></div>
//     </div>
//   </>
// );

// export default Loader;

{
  /* <Loader loading={loading} minDuration={1500}  /> */
}

// import React, { useEffect, useState } from "react";

// interface LoaderProps {
//   loading: boolean;
//   minDuration?: number; // milliseconds (default 1000)
// }

// const loaderStyle: React.CSSProperties = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   height: "100vh",
//   width: "100vw",
//   backgroundColor: "rgba(241, 231, 231, 0.8)",
//   zIndex: 9999,
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// };

// const spinnerStyle: React.CSSProperties = {
//   width: "50px",
//   height: "50px",
//   border: "6px solid #F59620",
//   borderTop: "6px solid transparent",
//   borderRadius: "50%",
//   animation: "spin 1s linear infinite",
// };

// const spinnerKeyframes = `
//   @keyframes spin {
//     0% { transform: rotate(0deg); }
//     100% { transform: rotate(360deg); }
//   }
// `;

// const Loader: React.FC<LoaderProps> = ({ loading, minDuration = 500 }) => {
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     let timeoutId: any;

//     if (loading) {
//       setVisible(true);
//     } else {
//       timeoutId = setTimeout(() => {
//         setVisible(false);
//       }, minDuration);
//     }

//     return () => clearTimeout(timeoutId);
//   }, [loading, minDuration]);

//   if (!visible) return null;

//   return (
//     <>
//      <div style={loaderStyle}>
//       <img
//         src="../assets/loader/Weconnect.gif" 
//         alt="Loading..."
//         style={{ width: "150px", height: "150px" }}
//       />
//     </div>
//     </>
//   );
// };

// export default Loader;


interface LoaderProps {
  loading: boolean;
}

const loaderStyle: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  height: "100vh",
  width: "100vw",
  backgroundColor: "rgba(241, 231, 231, 0.8)",
  zIndex: 9999,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const Loader: React.FC<LoaderProps> = ({ loading }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(loading);
  }, [loading]);

  if (!visible) return null;

  return (
    <div style={loaderStyle}>
      <img
        src="../assets/loader/Weconnect.gif"
        alt="Loading..."
        style={{ width: "250px", height: "auto" }}
      />
    </div>
  );
};

export default Loader;
